import { SettingRow } from 'components/node_settings/V4Settings/styled';
import styled from 'styled-components';

export const InfoPopupBullets = styled.ul`
    margin: 0;
    padding-left: 1.8rem;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
`;

export const StackedSettingRow = styled(SettingRow)`
    padding-top: 1rem;
    padding-bottom: 0.8rem;
`;

export const InlineDropdownWrapper = styled.div`
    align-self: flex-start;
`;

export const AxesEnabledValue = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
`;
